const bands = [
  { band: "160m", frequency: "1,810 to 2,000 kHz" },
  { band: "80m", frequency: "3,500 to 3,800 kHz" },
  { band: "40m", frequency: "7,000 to 7,200 kHz" },
  { band: "20m", frequency: "14,000 to 14,350 kHz" },
  { band: "15m", frequency: "21,000 to 21,450 kHz" },
  { band: "10m", frequency: "28,000 to 29,700 kHz" },
  { band: "6m", frequency: "50,000 to 54,000 kHz" },
  { band: "4m", frequency: "70,000 to 70,300 kHz" },
  { band: "2m", frequency: "144,000 to 146,000 kHz" },
  { band: "70cm", frequency: "430,000 to 440,000 kHz" },
  { band: "23cm", frequency: "1,240,000 to 1,300,000 kHz" }
];

// Helper function to generate wrong bands for given correct band
const generateWrongBands = (correctBand, allBands, count = 3) => {
  const wrongBands = allBands
    .filter(band => band !== correctBand)
    .sort(() => Math.random() - 0.5)
    .slice(0, count);
  return wrongBands;
};

// Helper function to generate wrong frequencies for given correct frequency
const generateWrongFrequencies = (correctFrequency, allFrequencies, count = 3) => {
  const wrongFrequencies = allFrequencies
    .filter(frequency => frequency !== correctFrequency)
    .sort(() => Math.random() - 0.5)
    .slice(0, count);
  return wrongFrequencies;
};

// Generate quiz questions from bands data
const generateBandsQuiz = () => {
  const allBands = bands.map(b => b.band);
  const allFrequencies = bands.map(b => b.frequency);
  const questions = [];
  let questionId = 1;

  // Generate two types of questions for each band
  bands.forEach((band, index) => {
    // Type 1: Given frequency range, what band is it?
    const wrongBands = generateWrongBands(band.band, allBands);
    const bandOptions = [band.band, ...wrongBands].sort(() => Math.random() - 0.5);
    const correctBandIndex = bandOptions.indexOf(band.band);
    
    questions.push({
      id: questionId++,
      question: `What amateur radio band covers the frequency range ${band.frequency}?`,
      options: bandOptions,
      correct: correctBandIndex,
      explanation: `The ${band.band} band covers the frequency range ${band.frequency}.`
    });

    // Type 2: Given band, what is the frequency range?
    if (index % 2 === 0) { // Only create every other one to avoid too many questions
      const wrongFrequencies = generateWrongFrequencies(band.frequency, allFrequencies);
      const frequencyOptions = [band.frequency, ...wrongFrequencies].sort(() => Math.random() - 0.5);
      const correctFrequencyIndex = frequencyOptions.indexOf(band.frequency);
      
      questions.push({
        id: questionId++,
        question: `What is the frequency range for the ${band.band} amateur radio band?`,
        options: frequencyOptions,
        correct: correctFrequencyIndex,
        explanation: `The ${band.band} band covers the frequency range ${band.frequency}.`
      });
    }
  });

  // Shuffle questions
  return questions.sort(() => Math.random() - 0.5);
};

export const bandsQuizData = {
  id: 'bands-quiz',
  title: 'Amateur Radio Bands Quiz',
  subtitle: 'Master amateur radio frequency allocations',
  description: 'Test your knowledge of amateur radio band frequency ranges and allocations',
  questions: generateBandsQuiz()
};

export default bandsQuizData;